module.exports = __webpack_public_path__ + "static/24-hour-hotline.b26d0596.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHome/images/24-hour-hotline.jpg
// module id = 170
// module chunks = 168707334958949